/**
 * @name          jQuery Boilerplate
 * @version       1.0
 * @lastmodified  2015-04-24
 * @package       html-css-js
 * @subpackage    jQuery plugin
 * @author        VI
 *
 * based on: http://jqueryboilerplate.com/
 */

;(function ($, window, document, undefined) {
	'use strict';

	var pluginName = 'video',
		defaults = {};

	// The actual plugin constructor
	function Plugin(element, options) {
		this.$element = $(element);
		this.options = $.extend({}, defaults, options);
		this.init();
	}

		// methods
		var methods = {
			init: function () {
				if(this.$element.hasClass('video--youtube')) {
					if (this.$element.hasClass('video--youtube-on-load')) {
						this.initYoutubeOnLoad();
					} else {
						this.initYoutube();
					}
				} else {
					this.initVideoJS();
				}
			},
			initYoutube: function () {
				var self = this;
				var script = document.createElement('script');
				script.type = 'text/javascript';
				script.src = 'https://www.youtube.com/iframe_api';
				document.body.appendChild(script);

				this.$element.find('.video__playButton').on('click', function() {
					self.playYoutubeVideo();
				});
			},
			initYoutubeOnLoad: function () {
				var $iframe = this.$element.find('.video__iframe');
				var src = this.$element.data('yt-id');
				$iframe.attr('src', this.createEmedUrl(src, 0));
			},
			playYoutubeVideo: function () {
				var $iframe = this.$element.find('.video__iframe');
				var src = this.$element.data('yt-id');
				// hide poster
				this.$element.addClass('is-running');
				// add iframe src in, starting the video
				$iframe.attr('src', this.createEmedUrl(src, 1));
				if(YT) {
					var player = new YT.Player($iframe[0], {
						events: {
							onReady: function() {
								player.playVideo();
							}
						}
					});
				}
			},
			createEmedUrl: function (id, autoplayValue) {
				var baseUrl = 'https://www.youtube-nocookie.com/embed/';
				var autoplay = 'autoplay=' +  autoplayValue;
				var rel = '&rel=0';
				var showinfo = '&showinfo=0';
				var jsAPI = '&enablejsapi=1';
				var color = '&color=white';
				var parameters = autoplay + rel + showinfo + color + jsAPI ;
				return baseUrl + id + '?' + parameters;
			},
			initVideoJS: function () {
				/*
				 * Note:
				 * This hook gets triggered for all players when creating a new player
				 * via videojs(...), hence the amount of triggers rapidly increases.
				 *
				 * @link https://en.wikipedia.org/wiki/1_%2B_2_%2B_3_%2B_4_%2B_%E2%8B%AF
				 */
				videojs.hook('setup', function (player) {
					var $video,
						videoPlayClass,
						$videoPlayButton;

					/*
					 * We need to cut off already initialized video players,
					 * due to the above-mentioned issue with exponentially
					 * increasing trigger numbers.
					 */
					if (player.customInitialized) {
						return;
					}

					$videoPlayButton = $(player.bigPlayButton.el_);
					$video = $videoPlayButton.closest('.video');
					videoPlayClass = $video.data('video-play-class');

					$videoPlayButton.addClass(videoPlayClass);

					player.customInitialized = true;
				});

				this.$element.moduleVideoPlayer({
					fluid: true,
					preload: 'metadata'
				});
			}
		};

	// build
	$.extend(Plugin.prototype, methods);

	// A really lightweight plugin wrapper around the constructor,
	// preventing against multiple instantiations

	$.fn[pluginName] = function (options) {
		this.each(function () {
			if (!$.data(this, 'plugin_' + pluginName)) {
				$.data(this, 'plugin_' + pluginName, new Plugin(this, options));
			}
		});
		return this;
	};

})(jQuery, window, document);
